import { Component } from "react";
import Card from "@/components/card";
import AzureRequest from "@/services/request";
import ForceGraph from "@/views/explore/forceGraph";
import Modal from "@/components/modal";
import ResultCard from "@/components/resultCard";
import Title from "@/components/title";
import Legend from "./legend";
import HelpDialog from "@/components/helpDialog";

class Galaxy extends Component {
  constructor(props) {
    super(props);
    this.state = {
      courseCard: undefined,
      showHelp: false,
      helpDialog: false
    };
    this.request = new AzureRequest();
    this.componentDidMount = this.componentDidMount.bind(this);
    this.handleCourseClick = this.handleCourseClick.bind(this);
    this.handleHelpClick = this.handleHelpClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleHelpDialog = this.handleHelpDialog.bind(this);
  }

  handleCourseClick(node = undefined) {
    if (node.level === 3) {
      this.setState({
        courseCard: node
      })
    }
    else if (node.id.includes('workField_gestion_-_rh_-_management')) this.setState({ helpDialog: 'Le saviez-vous ? Toutes les formations de l\'Université de Bourgogne peuvent conduire à des fonctions d\'encadrement !' })
  }

  handleHelpClick() {
    this.setState({ showHelp: !this.state.showHelp })
  }

  handleHelpDialog() {
    this.setState({ helpDialog: false })
  }

  closeModal() {
    this.setState({ courseCard: undefined })
  }

  componentDidMount() {

    this.request.post({
      search: "*",
      facets: [
        "Domaine_du_MESRI,count:200",
        "Domaine_Professionnel,count:200"
      ],
      filter: `Domaine_Professionnel/any()`,
      top: 1000,
    }).then((response) => {
      this.formatData3(response);
      this.drawGalaxy();
    }).catch((error) => {
      console.log(error)
    })
  }

  // componentDidUpdate() {
  //   (this.state.selected)
  //   this.drawGalaxy();
  // }

  formatData3(data) {
    const fieldNodes = data['@search.facets'].Domaine_du_MESRI.map((field) => {
      return {
        id: `field_${field.value.replaceAll(' ', '_')}`,
        name: field.value,
        level: 1
      }
    });
    const workFieldNodes = data['@search.facets'].Domaine_Professionnel.map((workField) => {
      return {
        id: `workField_${workField.value.replaceAll(' ', '_')}`,
        name: workField.value,
        level: 2
      }
    });
    let courseNodes = [];
    this.links = [];
    data.value.forEach((course) => {
      // (course)
      const courseNode = {
        ...course,
        id: `course_${course.AzureSearch_DocumentKey}`,
        name: course.Domaine_du_MESRI_1,
        level: 3
      };
      courseNodes.push(courseNode);
      const fieldNode = fieldNodes.find((item) => item.name === course.Domaine_du_MESRI.toLowerCase())
      // for each workField, add links with field and course
      course.Domaine_Professionnel.forEach((workField) => {
        const workFieldNode = workFieldNodes.find((item) => item.name === workField.toLowerCase());
        if (!fieldNode || !workFieldNode) {
          return;
        }
        this.links.push({
          source: fieldNode.id,
          target: workFieldNode.id
        });
        this.links.push({
          source: workFieldNode.id,
          target: courseNode.id
        })
      })
    });
    this.nodes = [
      ...fieldNodes,
      ...workFieldNodes,
      ...courseNodes
    ];
  }

  async drawGalaxy() {
    const galaxy = ForceGraph({
      baseNodes: this.nodes.sort((a, b) => b - a),
      baseLinks: this.links
    }, {
      selectedId: this.props.selected,
      nodeId: d => d.id,
      nodeGroup: d => d.group,
      nodeTitle: d => d.name,
      nodeRadius: {
        1: 36,
        2: 26,
        3: 3
      },
      colors: {
        1: '#f47b20',
        2: '#04b1e8',
        3: '#c36dc8',
      },
      nodeStrokeWidth: 1,
      nodeStrength: -15,
      onCourseClick: this.handleCourseClick
    });
    if (document.querySelector('#galaxy').children.length > 0) {
      document.querySelector('#galaxy svg').remove();
    }
    document.querySelector('#galaxy').append(galaxy);
  }

  render() {
    const showProfessions = this.state.courseCard?.Metiers_1 && this.state.courseCard.Metiers_1.length > 0;
    console.log(showProfessions);
    return (
      <div className="relative">
        <div className="absolute top-0 left-4 flex items-start text-white gap-2">
          <button className="hover:text-orange fill-current" onClick={this.handleHelpClick}>
            <svg xmlns="http://www.w3.org/2000/svg" width="44.49" height="44.49" viewBox="0 0 44.49 44.49"><g transform="translate(0 0)"><circle cx="20" cy="20" r="20" transform="translate(1.5 1.5)" fill="transparent" /><path d="M180.439,183.373a2.034,2.034,0,0,0-2.817.576,22.24,22.24,0,1,0,6.328-6.327,2.033,2.033,0,1,0,2.242,3.393,18.173,18.173,0,1,1-5.176,5.176A2.033,2.033,0,0,0,180.439,183.373Z" transform="translate(-173.95 -173.95)" /></g><path d="M8.492,0A7.349,7.349,0,0,0,1.964,3.453.911.911,0,0,0,2.16,4.7L3.8,5.94a.91.91,0,0,0,1.261-.157c.95-1.19,1.655-1.876,3.139-1.876,1.167,0,2.61.751,2.61,1.882,0,.855-.706,1.295-1.858,1.941C7.6,8.484,5.827,9.421,5.827,11.766v.371a.91.91,0,0,0,.91.91H9.486a.91.91,0,0,0,.91-.91v-.219c0-1.626,4.751-1.693,4.751-6.092C15.148,2.513,11.711,0,8.492,0ZM8.179,15.231a2.627,2.627,0,1,0,2.627,2.627A2.63,2.63,0,0,0,8.179,15.231Z" transform="translate(14.2 12)" /></svg>
          </button>
          {this.state.showHelp &&
            <div className="bg-gray-darkest">
              <p>Cliquer sur les planètes pour naviguer dans la galaxie des formations</p>
              <p>Cliquer sur une planète Formation pour afficher la fiche correspondante</p>
              <p>Pour revenir à la vue globale, faire un clic droit sur une planète</p>
            </div>
          }
        </div>
        <div className="absolute top-0 right-4">
          <Legend color="orange">Domaine de formation</Legend>
          <Legend color="blue">Domaine professionnel</Legend>
          <Legend color="purple">Formation</Legend>
        </div>
        <div id="galaxy" className="w-11/12 m-auto h-galaxy border-white"></div>
        {this.state.courseCard &&
          <Modal onClick={this.closeModal} border="gray-light">
            <div className={`relative grid ${showProfessions && 'md:grid-cols-3'} grid-cols-1 border border-gray-darkest h-full overflow-auto`}>
              <div className="md:col-span-2 col-span-1 border border-gray-light border-r-0 h-full">
                <ResultCard course={this.state.courseCard} />
              </div>
              {showProfessions &&
                <Card
                  width="1"
                  height="1"
                  justify="start"
                  background="white bg-opacity-80"
                  textColor="gray-darkest"
                  border="gray-light"
                >
                  <Title
                    title="Exemples de métiers"
                    subtitle=""
                    variant="3"
                    justify="left"
                  />
                  <ul className="list-disc marker-orange ml-2">
                    {this.state.courseCard.Metiers_1.map((job, index) => (
                      <li key={index}>{job}</li>
                    ))}
                  </ul>
                </Card>
              }
            </div>
          </Modal>
        }
        {this.state.helpDialog && <HelpDialog handleClose={this.handleHelpDialog}>{this.state.helpDialog}</HelpDialog>}
      </div>
    );
  }
}

export default Galaxy;